import { Pipe, PipeTransform } from '@angular/core';
import { EntityRef, EntityType } from 'src/app/core/settings/settings.service';
import { Entity } from './entity-search.service';

@Pipe({
  name: 'entityPath',
  standalone: true,
})
export class EntityPathPipe implements PipeTransform {
  transform(listResult: Entity): string {
    if (
      listResult.entityType === EntityType.company ||
      listResult.entityType === EntityType.stack ||
      listResult.entityType === EntityType.stack_deprecated
    ) {
      return listResult.name;
    }

    const company = listResult.path.find(
      (p) => p.entityType === EntityType.company,
    );

    return (
      company.name +
      this.addParentGroup(listResult.path) +
      ' > ' +
      listResult.name
    );
  }

  addParentGroup(path: EntityRef[]): string {
    const pathCopy = path.slice(0, path.length - 1).reverse();
    const parentGroup = pathCopy.find((p) => p.entityType === EntityType.group);
    const connector = pathCopy.length > 2 ? ' > ... > ' : ' > ';

    return parentGroup ? connector + parentGroup.name : '';
  }
}
